import GlucoseSlider from "./glucose-slider/GlucoseSlider";
import TriedTreatment from "./heelpain/TriedTreatment";
import PainSlider from "./pain-slider/PainSlider";
export const customInputs = {
    PainSlider,
    GlucoseSlider,
    TriedTreatment,
};
